import { Heading, SimpleGrid, Flex, Image, Box, Link, chakra, Center } from "@chakra-ui/react";
import gitlogo from '../logos/github-icon-1.svg';
import netlifylogo from '../logos/netlify.svg';
import htmllogo from '../logos/html-1.svg';
import csslogo from '../logos/css-3.svg';
import jslogo from '../logos/javascript-1.svg';
import reactlogo from '../logos/react-2.svg';
import chakralogo from '../logos/ChakraLogo.png';
import appleClone from '../projectsPhoto/AppleClone.png';
import tatamgClone from '../projectsPhoto/Tata1mgClone.png';
import tripclone from '../projectsPhoto/TripAdvisor Clone.png';
// import portfolioPhoto from '../projectsPhoto/Portfolio.png';
import lenskartClone from '../projectsPhoto/LenskartClone.png';
import node from '../logos/nodejs-icon.svg'
import express from '../logos/express-109.svg'
import mongo from '../logos/mongodb-icon-1.svg'

export const Projects = () => {
    return (
        <div id="projects" style={{marginTop:'20px',borderBottom:'1px solid gray'}}>
            <Heading color={'text'}>My <strong style={{color:'#4FC3F7'}}>Projects</strong></Heading>
            <SimpleGrid columns={[1,2]} w={{base:'95%', md:'90%'}} m={'auto'}>
                {/* Lenskart Clone */}
                <Flex
                    // border={'1px solid red'}
                    className="project-card"
                    _dark={{
                        bg: "#3e3e3e",
                    }}
                    p={50}
                    w="full"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Box
                        mx="auto"
                        rounded="lg"
                        shadow="md"
                        bg="white"
                        _dark={{
                            bg: "gray.800",
                        }}
                        maxW="2xl"
                    >
                        <Image
                            roundedTop="lg"
                            w="full"
                            h={64}
                            borderBottom={'1px solid black'}
                            // fit='fill'
                            src={lenskartClone}
                            alt="LenskartClone"
                        />

                        <Box p={6}>
                            <Box>
                                <chakra.p
                                    className="project-title"
                                    display="block"
                                    color="gray.800"
                                    _dark={{
                                        color: "white",
                                    }}
                                    fontWeight="bold"
                                    fontSize="xl"
                                    // mt={1}
                                >
                                    Lenskart Clone
                                </chakra.p>
                                <chakra.p
                                    className="project-description"
                                    mt={2}
                                    fontSize="sm"
                                    color="gray.600"
                                    _dark={{
                                        color: "gray.400",
                                    }}
                                >
                                    Lenskart is the leading e-commerce portal for eyewear in India where you can get variety of sunglasses, eyeglasses etc.
                                </chakra.p>
                                <chakra.p
                                    className="project-tech-stack"
                                    mt={2}
                                    fontSize="sm"
                                    color="gray.800"
                                    fontWeight="bold"
                                    _dark={{
                                        color: "gray.400",
                                    }}
                                >
                                    Tech Stack:
                                    <Center>
                                     <Image m={'2px'} w={'30px'} src={reactlogo}/>
                                     <Image m={'2px'} w={'25px'} src={node}/>
                                     <Image m={'2px'} w={'40px'} src={express}/>
                                     <Image m={'2px'} ml={'-2'} w={'30px'} src={mongo}/>
                                    </Center>
                                </chakra.p>
                            </Box>

                            <Box mt={3}>
                                <Flex flexDirection={{base:'column', md:'column', lg:'row'}} alignItems="center" justifyContent={'space-around'}>
                                    <Flex alignItems="center" mt={'10px'}>
                                        <Image
                                            // h={10}
                                            // fit="cover"
                                            // rounded="full"
                                            w={'20px'}
                                            src={gitlogo}
                                            alt="Avatar"
                                        />
                                        <Link
                                            className="project-github-link"
                                            mx={2}
                                            isExternal
                                            href='https://github.com/RutuvikP/shiny-blade-5949'
                                            fontWeight="bold"
                                            color="gray.700"
                                            _dark={{
                                                color: "gray.200",
                                            }}
                                        >
                                            GitHub
                                        </Link>
                                    </Flex>
                                    <Flex alignItems="center" mt={'10px'}>
                                        <Image
                                            // h={10}
                                            // fit="cover"
                                            // rounded="full"
                                            w={'20px'}
                                            src={netlifylogo}
                                            alt="Avatar"
                                        />
                                        <Link
                                            className="project-deployed-link"
                                            mx={2}
                                            isExternal
                                            href='https://cleardekho-rutuvikp.vercel.app/'
                                            fontWeight="bold"
                                            color="gray.700"
                                            _dark={{
                                                color: "gray.200",
                                            }}
                                        >
                                            Deployed
                                        </Link>
                                    </Flex>
                                </Flex>
                            </Box>
                        </Box>
                    </Box>
                </Flex>
                {/* Apple CLone */}
                <Flex
                    // border={'1px solid red'}
                    className="project-card"
                    _dark={{
                        bg: "#3e3e3e",
                    }}
                    p={50}
                    w="full"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Box
                        mx="auto"
                        rounded="lg"
                        shadow="md"
                        bg="white"
                        _dark={{
                            bg: "gray.800",
                        }}
                        maxW="2xl"
                    >
                        <Image
                            roundedTop="lg"
                            w="full"
                            h={64}
                            borderBottom={'1px solid black'}
                            // fit='fill'
                            src={appleClone}
                            alt="AppleClone"
                        />

                        <Box p={6}>
                            <Box>
                                <chakra.p
                                    className="project-title"
                                    display="block"
                                    color="gray.800"
                                    _dark={{
                                        color: "white",
                                    }}
                                    fontWeight="bold"
                                    fontSize="xl"
                                    // mt={1}
                                >
                                    Apple Clone
                                </chakra.p>
                                <chakra.p
                                    className="project-description"
                                    mt={2}
                                    fontSize="sm"
                                    color="gray.600"
                                    _dark={{
                                        color: "gray.400",
                                    }}
                                >
                                    Apple is a consumer and electronics company famous for creating the iPhone, iPad and Macintosh computers.
                                </chakra.p>
                                <chakra.p
                                    className="project-tech-stack"
                                    mt={2}
                                    fontSize="sm"
                                    color="gray.800"
                                    fontWeight="bold"
                                    _dark={{
                                        color: "gray.400",
                                    }}
                                >
                                    Tech Stack:
                                    <Center>
                                     <Image m={'2px'} w={'30px'} src={htmllogo}/>
                                     <Image m={'2px'} w={'30px'} src={csslogo}/>
                                     <Image m={'2px'} w={'30px'} src={jslogo}/>
                                    </Center>
                                </chakra.p>
                            </Box>

                            <Box mt={3}>
                                <Flex flexDirection={{base:'column', md:'column', lg:'row'}} alignItems="center" justifyContent={'space-around'}>
                                    <Flex alignItems="center" mt={'10px'}>
                                        <Image
                                            // h={10}
                                            // fit="cover"
                                            // rounded="full"
                                            w={'20px'}
                                            src={gitlogo}
                                            alt="Avatar"
                                        />
                                        <Link
                                            className="project-github-link"
                                            mx={2}
                                            isExternal
                                            href='https://github.com/Imran2909/enormous-step-3337'
                                            fontWeight="bold"
                                            color="gray.700"
                                            _dark={{
                                                color: "gray.200",
                                            }}
                                        >
                                            GitHub
                                        </Link>
                                    </Flex>
                                    <Flex alignItems="center" mt={'10px'}>
                                        <Image
                                            // h={10}
                                            // fit="cover"
                                            // rounded="full"
                                            w={'20px'}
                                            src={netlifylogo}
                                            alt="Avatar"
                                        />
                                        <Link
                                            className="project-deployed-link"
                                            mx={2}
                                            isExternal
                                            href='https://calm-medovik-08f3fc.netlify.app/'
                                            fontWeight="bold"
                                            color="gray.700"
                                            _dark={{
                                                color: "gray.200",
                                            }}
                                        >
                                            Deployed
                                        </Link>
                                    </Flex>
                                </Flex>
                            </Box>
                        </Box>
                    </Box>
                </Flex>
                {/* Tata1mg Clone */}
                <Flex
                    className="project-card"
                    _dark={{
                        bg: "#3e3e3e",
                    }}
                    p={50}
                    w="full"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Box
                        mx="auto"
                        rounded="lg"
                        shadow="md"
                        bg="white"
                        _dark={{
                            bg: "gray.800",
                        }}
                        maxW="2xl"
                    >
                        <Image
                            roundedTop="lg"
                            w="full"
                            h={64}
                            borderBottom={'1px solid black'}
                            // fit='fill'
                            src={tatamgClone}
                            alt="AppleClone"
                        />

                        <Box p={6}>
                            <Box>
                                <chakra.p
                                    className="project-title"
                                    display="block"
                                    color="gray.800"
                                    _dark={{
                                        color: "white",
                                    }}
                                    fontWeight="bold"
                                    fontSize="xl"
                                    // mt={1}
                                >
                                    Tata1mg Clone
                                </chakra.p>
                                <chakra.p
                                    className="project-description"
                                    mt={2}
                                    fontSize="sm"
                                    color="gray.600"
                                    _dark={{
                                        color: "gray.400",
                                    }}
                                >
                                    Tata 1mg, is a healthcare platform in India. It provides services, including e-pharmacy, diagnostics, e-consultation and health content.
                                </chakra.p>
                                <chakra.p
                                    className="project-tech-stack"
                                    mt={2}
                                    fontSize="sm"
                                    color="gray.800"
                                    fontWeight="bold"
                                    _dark={{
                                        color: "gray.400",
                                    }}
                                >
                                    Tech Stack:
                                    <Center>
                                     <Image m={'2px'} w={'30px'} src={reactlogo}/>
                                     <Image m={'2px'} w={'40px'} src={chakralogo}/>
                                    </Center>
                                </chakra.p>
                            </Box>

                            <Box mt={3}>
                                <Flex flexDirection={{base:'column', md:'column', lg:'row'}} alignItems="center" justifyContent={'space-around'}>
                                    <Flex alignItems="center" mt={'10px'}>
                                        <Image
                                            // h={10}
                                            // fit="cover"
                                            // rounded="full"
                                            w={'20px'}
                                            src={gitlogo}
                                            alt="Avatar"
                                        />
                                        <Link
                                            className="project-github-link"
                                            mx={2}
                                            isExternal
                                            href='https://github.com/RutuvikP/awesome-volleyball-5374'
                                            fontWeight="bold"
                                            color="gray.700"
                                            _dark={{
                                                color: "gray.200",
                                            }}
                                        >
                                            GitHub
                                        </Link>
                                    </Flex>
                                    <Flex alignItems="center" mt={'10px'}>
                                        <Image
                                            // h={10}
                                            // fit="cover"
                                            // rounded="full"
                                            w={'20px'}
                                            src={netlifylogo}
                                            alt="Avatar"
                                        />
                                        <Link
                                            className="project-deployed-link"
                                            mx={2}
                                            isExternal
                                            href='https://health-connect-webapp.netlify.app/'
                                            fontWeight="bold"
                                            color="gray.700"
                                            _dark={{
                                                color: "gray.200",
                                            }}
                                        >
                                            Deployed
                                        </Link>
                                    </Flex>
                                </Flex>
                            </Box>
                        </Box>
                    </Box>
                </Flex>
                {/* TripAdvisor Clone */}
                <Flex
                    // border={'1px solid red'}
                    className="project-card"
                    _dark={{
                        bg: "#3e3e3e",
                    }}
                    p={50}
                    w="full"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Box
                        mx="auto"
                        rounded="lg"
                        shadow="md"
                        bg="white"
                        _dark={{
                            bg: "gray.800",
                        }}
                        maxW="2xl"
                    >
                        <Image
                            roundedTop="lg"
                            w="full"
                            h={64}
                            borderBottom={'1px solid black'}
                            // fit='fill'
                            src={tripclone}
                            alt="AppleClone"
                        />

                        <Box p={6}>
                            <Box>
                                <chakra.p
                                    className="project-title"
                                    display="block"
                                    color="gray.800"
                                    _dark={{
                                        color: "white",
                                    }}
                                    fontWeight="bold"
                                    fontSize="xl"
                                    // mt={1}
                                >
                                    TripAdvisor Clone
                                </chakra.p>
                                <chakra.p
                                    className="project-description"
                                    mt={2}
                                    fontSize="sm"
                                    color="gray.600"
                                    _dark={{
                                        color: "gray.400",
                                    }}
                                >
                                    TripAdvisor is an online travel company where customers can make hotel reservations as well as reservations for travel, lodging, and dining.
                                </chakra.p>
                                <chakra.p
                                    className="project-tech-stack"
                                    mt={2}
                                    fontSize="sm"
                                    color="gray.800"
                                    fontWeight="bold"
                                    _dark={{
                                        color: "gray.400",
                                    }}
                                >
                                    Tech Stack:
                                    <Center>
                                     <Image m={'2px'} w={'30px'} src={htmllogo}/>
                                     <Image m={'2px'} w={'30px'} src={csslogo}/>
                                     <Image m={'2px'} w={'30px'} src={jslogo}/>
                                    </Center>
                                </chakra.p>
                            </Box>

                            <Box mt={3}>
                                <Flex flexDirection={{base:'column', md:'column', lg:'row'}} alignItems="center" justifyContent={'space-around'}>
                                    <Flex alignItems="center" mt={'10px'}>
                                        <Image
                                            // h={10}
                                            // fit="cover"
                                            // rounded="full"
                                            w={'20px'}
                                            src={gitlogo}
                                            alt="Avatar"
                                        />
                                        <Link
                                            className="project-github-link"
                                            mx={2}
                                            isExternal
                                            href='https://github.com/RutuvikP/adaptable-spoon-4476'
                                            fontWeight="bold"
                                            color="gray.700"
                                            _dark={{
                                                color: "gray.200",
                                            }}
                                        >
                                            GitHub
                                        </Link>
                                    </Flex>
                                    <Flex alignItems="center" mt={'10px'}>
                                        <Image
                                            // h={10}
                                            // fit="cover"
                                            // rounded="full"
                                            w={'20px'}
                                            src={netlifylogo}
                                            alt="Avatar"
                                        />
                                        <Link
                                            className="project-deployed-link"
                                            mx={2}
                                            isExternal
                                            href='https://marvelous-rolypoly-fc7f83.netlify.app/index.html'
                                            fontWeight="bold"
                                            color="gray.700"
                                            _dark={{
                                                color: "gray.200",
                                            }}
                                        >
                                            Deployed
                                        </Link>
                                    </Flex>
                                </Flex>
                            </Box>
                        </Box>
                    </Box>
                </Flex>
                {/* Portfolio */}
                {/* <Flex
                    className="project-card"
                    _dark={{
                        bg: "#3e3e3e",
                    }}
                    p={50}
                    w="full"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Box
                        mx="auto"
                        rounded="lg"
                        shadow="md"
                        bg="white"
                        _dark={{
                            bg: "gray.800",
                        }}
                        maxW="2xl"
                    >
                        <Image
                            roundedTop="lg"
                            w="full"
                            h={64}
                            borderBottom={'1px solid black'}
                            // fit='fill'
                            src={portfolioPhoto}
                            alt="AppleClone"
                        />

                        <Box p={6}>
                            <Box>
                                <chakra.p
                                    className="project-title"
                                    display="block"
                                    color="gray.800"
                                    _dark={{
                                        color: "white",
                                    }}
                                    fontWeight="bold"
                                    fontSize="xl"
                                    // mt={1}
                                >
                                    Portfolio
                                </chakra.p>
                                <chakra.p
                                    className="project-description"
                                    mt={2}
                                    fontSize="sm"
                                    color="gray.600"
                                    _dark={{
                                        color: "gray.400",
                                    }}
                                >
                                    This project is my own Portfolio website where you can find all information about me, my skills and my past projects.
                                </chakra.p>
                                <chakra.p
                                    className="project-tech-stack"
                                    mt={2}
                                    fontSize="sm"
                                    color="gray.800"
                                    fontWeight="bold"
                                    _dark={{
                                        color: "gray.400",
                                    }}
                                >
                                    Tech Stack:
                                    <Center>
                                     <Image m={'2px'} w={'30px'} src={reactlogo}/>
                                     <Image m={'2px'} w={'40px'} src={chakralogo}/>
                                    </Center>
                                </chakra.p>
                            </Box>

                            <Box mt={3}>
                                <Flex flexDirection={{base:'column', md:'column', lg:'row'}} alignItems="center" justifyContent={'space-around'}>
                                    <Flex alignItems="center" mt={'10px'}>
                                        <Image
                                            // h={10}
                                            // fit="cover"
                                            // rounded="full"
                                            w={'20px'}
                                            src={gitlogo}
                                            alt="Avatar"
                                        />
                                        <Link
                                            className="project-github-link"
                                            mx={2}
                                            isExternal
                                            href='https://github.com/RutuvikP/RutuvikP.github.io'
                                            fontWeight="bold"
                                            color="gray.700"
                                            _dark={{
                                                color: "gray.200",
                                            }}
                                        >
                                            GitHub
                                        </Link>
                                    </Flex>
                                    <Flex alignItems="center" mt={'10px'}>
                                        <Image
                                            // h={10}
                                            // fit="cover"
                                            // rounded="full"
                                            w={'20px'}
                                            src={netlifylogo}
                                            alt="Avatar"
                                        />
                                        <Link
                                            className="project-deployed-link"
                                            mx={2}
                                            isExternal
                                            href='https://rutuvikp.github.io/'
                                            fontWeight="bold"
                                            color="gray.700"
                                            _dark={{
                                                color: "gray.200",
                                            }}
                                        >
                                            Deployed
                                        </Link>
                                    </Flex>
                                </Flex>
                            </Box>
                        </Box>
                    </Box>
                </Flex> */}
            </SimpleGrid>
        </div>
    )
};

